import {
  NotificationService,
  ToastStyle,
} from '@omni/services/notification/notification.service';
import { Account } from '@omni/classes/account/account.class';
import { Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/** The account's New order action (OMNI-60747), shared by its details and its full timeline. */
export const NEW_ORDER_ACTION = 'create-order-capture';

export function newOrderButton(translate: TranslateService) {
  return {
    id: NEW_ORDER_ACTION,
    imgSrc: 'assets/imgs/glance-order-capture.svg',
    name: translate.instant('OC_NEW_ORDER'),
    isDisabled: false,
    align: 'right',
  };
}

/**
 * Opens the order flow over the whole shell, the rep's drafts for the account offered first. Never
 * rejects: on the web, offline, the lazy chunks may not load, and the rep is told.
 */
export async function openNewOrder(
  injector: Injector,
  account: Account,
  event?: Event,
): Promise<void> {
  try {
    const opener =
      await import('@omni/services/order-capture/order-capture-opener.service').then(
        (m) => m.OrderCaptureOpener,
      );
    await injector.get(opener).openForAccount(account, event);
  } catch (error) {
    console.error('Order capture could not open', error);
    const message = injector
      .get(TranslateService)
      .instant('APP_UI_LOAD_FAILED');
    injector
      .get(NotificationService)
      .notify(message, 'Order Capture', 'top', ToastStyle.DANGER);
  }
}
